module.exports = __webpack_public_path__ + "img/Bilder_Website_Shop2.7cd67e74.png";